<template>
  <svg role="img" focusable="false" xmlns="http://www.w3.org/2000/svg" :style="style" class="c-icon" :class="`c-icon-${name}`">
    <title v-if="title">{{ title }}</title>
    <use :xlink:href="`#icon-${name}`" xmlns:xlink="http://www.w3.org/1999/xlink"/>
  </svg>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    name: string;
    title?: string;
    size?: number; // common values: 12, 16, 18, 20, 24, 32
  }>();

  const style = computed(() => {
    const rems = (props.size ?? 16) / 16;
    return {
      width: rems + 'rem',
      height: rems + 'rem',
    };
  });
</script>

<style lang="scss">
  .c-icon {
    fill: currentColor;
    flex-shrink: 0;
    vertical-align: middle;
  }
</style>
